<template>
    <div class="auth-screen" :class="{ 'auth-screen--mobile': isMobile }">
        <div class="brand-side">
            <brand-backdrop />
            <div class="brand-accent"></div>
            <div class="brand-content">
                <img :src="logoSidebar" class="brand-logo" alt="" />
                <div class="brand-tagline">
                    {{ $t('entrance.brand_tagline_1') }}<br>
                    <span class="brand-tagline-accent">{{ $t('entrance.brand_tagline_2') }}</span>
                </div>
                <div class="brand-sub">{{ $t('entrance.brand_subtitle') }}</div>
            </div>
        </div>

        <div class="form-side" :class="{ 'form-side--top': alignTop }">
            <div v-if="$slots.topLink" class="form-side-top">
                <slot name="topLink" />
            </div>
            <div class="form-side-content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import BrandBackdrop from '@/components/common/BrandBackdrop'

export default {
    name: 'AuthLayout',
    components: {
        BrandBackdrop,
    },
    props: {
        alignTop: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            logoSidebar: require('@/assets/img/logo_sidebar.png'),
        }
    }
}
</script>

<style scoped>
.auth-screen {
    display: flex;
    align-items: stretch;
    height: 100vh;
    overflow: hidden;
}

.brand-side {
    position: relative;
    flex: 0 0 58%;
    height: 100vh;
    overflow: hidden;
    background: #06080C;
}

.auth-screen--mobile {
    flex-direction: column;
    align-items: stretch;
    height: auto;
    min-height: 100vh;
    overflow: visible;
}

.auth-screen--mobile .brand-side {
    position: static;
    flex: 0 0 auto;
    height: auto;
    min-height: 0;
}

.auth-screen--mobile .form-side {
    height: auto;
    min-height: 0;
    overflow: visible;
    padding-top: 32px;
}

.auth-screen--mobile .brand-content {
    position: relative;
    z-index: 1;
    justify-content: flex-start;
    padding: calc(32px + var(--safe-area-inset-top, 0px)) 28px 32px;
}

.auth-screen--mobile .brand-logo {
    width: 130px;
    margin-bottom: 14px;
}

.auth-screen--mobile .brand-tagline {
    font-size: 24px;
    margin-bottom: 0;
}

.auth-screen--mobile .brand-sub {
    display: none;
}

.auth-screen--mobile .brand-accent {
    display: none;
}

.brand-accent {
    position: absolute;
    top: 10%;
    right: 0;
    bottom: 10%;
    width: 2px;
    background: linear-gradient(to bottom, transparent, rgba(204, 255, 51, 0.3) 40%, rgba(51, 153, 153, 0.3) 60%, transparent);
}

.brand-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 60px;
}

.brand-logo {
    width: 150px;
    height: auto;
    display: block;
    margin-bottom: 32px;
}

.brand-tagline {
    font-size: 38px;
    font-weight: 800;
    color: #F2F5FA;
    line-height: 1.15;
    letter-spacing: -0.03em;
    margin-bottom: 20px;
}

.brand-tagline-accent {
    background: linear-gradient(135deg, #CCFF33 0%, #66CCCC 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.brand-sub {
    font-size: 15px;
    font-weight: 400;
    color: rgba(242, 245, 250, 0.5);
    line-height: 1.6;
    max-width: 340px;
}

.form-side {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    overflow-y: auto;
    padding: 32px 24px;
    background: var(--v-surface-base);
}

.form-side--top {
    padding-top: 64px;
}

.form-side-content {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: auto 0;
}

.form-side--top .form-side-content {
    margin: 0;
}

.form-side-top {
    position: absolute;
    top: 0;
    right: 0;
    padding: 16px 24px;
    padding-top: calc(16px + var(--safe-area-inset-top, 0px));
    z-index: 1;
}

.form-side-top ::v-deep .v-btn {
    font-size: 14px;
    font-weight: 500;
}
</style>
